const mainTemplate = require('./emailTemplate');

export function contactUsCustomerHTML(emailPackage) {
  const header = 'Thank You!';
  const body = `
  <p style="Margin-top: 0;Margin-bottom: 0;">
    Thank you <strong>${emailPackage.emailData.name}</strong>, for reaching out to us!  
    We will look over your information and a member of our team will reach back out you as soon as possible.  
    In the meantime, feel free to check our site out to for more information.
  </p>
  <p style="Margin-top: 20px;Margin-bottom: 0;">
    Thanks again for considering Ingalls Image for any and all of your media needs,
  </p>
  <p style="Margin-top: 20px;Margin-bottom: 0;">~The Ingalls Image Team</p>
  `;
  const htmlBody = mainTemplate.iiTemplate(header, body);
  return htmlBody;
}

export function contactUSCustomerText(emailPackage) {
  const textBody = `Thank you ${emailPackage.emailData.name} for reaching out to us!  
  We will look over your information and a member of our team will reach back out to you as soon as possible.  
  In the meantime, feel free to check our site out for more information.
  Thanks again for considering Ingalls Image for any and all of your media needs, 
  ~The Ingalls Image Team`;
  return textBody;
}

export function contactUsIIHTML(emailPackage) {
  const header = 'New Contact';
  const body = `
    <h3>${emailPackage.emailData.name} has reached out with the following inquiry:</h3>
    <p style="Margin-top: 0;Margin-bottom: 0;"><strong>Phone:</strong> ${emailPackage.emailData.phone}</p>
    <p style="Margin-top: 0;Margin-bottom: 0;"><strong>Email:</strong> ${emailPackage.emailData.email}</p>
    <p style="Margin-top: 0;Margin-bottom: 0;"><strong>Service(s):</strong> ${emailPackage.emailData.services}</p>
    <p style="Margin-top: 0;Margin-bottom: 0;"><strong>Contact Time(s):</strong> ${emailPackage.emailData.contactTime}</p>
    <p style="Margin-top: 0;Margin-bottom: 0;"><strong>Message:</strong> ${emailPackage.emailData.message}</p>
  `;
  const htmlBody = mainTemplate.iiTemplate(header, body);
  return htmlBody;
}

export function contactUsIIText(emailPackage) {
  const textBody = `New Contact From ${emailPackage.emailData.name}.  INFO:{p} ${emailPackage.emailData.phone} || {e} ${emailPackage.emailData.email} ||
   {s} ${emailPackage.emailData.services} || {t} ${emailPackage.emailData.contactTime} || {m} ${emailPackage.emailData.message}`;
  return textBody;
}
